package one.healthium.log_period.ui.utils

interface LogPeriodEvents {
    data object PeriodUpdated : LogPeriodEvents
}